module.exports = "pegasus/assets/two-column-text-preview.png";